/* Eden Garden cookie consent. The official Shopify API owns every consent value.
 * No audit detection, request interception, cookie writes or console filtering.
 * The appearance and copy are the previously published banner's own markup.
 */
(() => {
  'use strict';
  const script = document.getElementById('eg-cookie-banner-script');
  if (!script || window.edenCookieBanner) return;
  const templates = {"banner": window.EdenI18n.h("text_7efccfa80b24").replace('https://hoteledengardenspa.ro/policies/privacy-policy', window.EdenI18n.url('/pages/politica-de-confidentialitate')), "preferences": window.EdenI18n.h("text_01b06d226aaa")};
  const categories = ['preferences', 'marketing', 'analytics'];
  let api, root, banner, preferences, dialog, ready;
  let returnFocus, bannerWasOpen = false, saving = false, fallbackStarted = false;
  let modalBackground = [], previousOverflow = '', saveSequence = 0;
  const oldPrivacyBanner = window.privacyBanner;

  function fallback(showPreferences = false) {
    if (fallbackStarted) return;
    fallbackStarted = true;
    releaseModal();
    root?.remove();
    document.getElementById('eg-cookie-banner-style')?.remove();
    if (window.privacyBanner === facade) window.privacyBanner = oldPrivacyBanner;
    const native = document.createElement('script');
    native.src = script.dataset.nativeSrc;
    native.async = true;
    if (showPreferences) native.onload = () => window.privacyBanner?.showPreferences?.();
    document.head.append(native);
  }

  function consent() { return api.currentVisitorConsent(); }
  function undecided() {
    const state = consent();
    return categories.every(key => state[key] === '');
  }
  function syncInputs() {
    const state = consent();
    categories.forEach(key => {
      const input = root.querySelector(`#shopify-pc__prefs__${key}-input`);
      input.checked = state[key] === 'yes';
      syncIcon(input);
    });
    dialog.dataset.consent = categories.map(key => state[key] === 'yes' ? '1' : '0').join('');
  }
  function syncIcon(input) {
    input.parentElement.querySelectorAll('[data-icon-type]').forEach(icon => {
      icon.style.display = (icon.dataset.iconType === 'checked') === input.checked ? 'block' : 'none';
    });
  }
  function clearErrors() {
    root.querySelectorAll('[data-cookie-error]').forEach(error => { error.hidden = true; });
  }
  function showError(container) {
    let error = container.querySelector('[data-cookie-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.cookieError = '';
      error.setAttribute('role', 'alert');
      container.append(error);
    }
    error.textContent = window.EdenI18n.t("text_d1b93e8a3e3f");
    error.hidden = false;
  }
  function setBusy(value) {
    saving = value;
    root.querySelectorAll('button, input:not([aria-readonly="true"])').forEach(el => { el.disabled = value; });
    banner.setAttribute('aria-busy', String(value));
    dialog.setAttribute('aria-busy', String(value));
  }
  function releaseModal() {
    if (!modalBackground.length) return;
    modalBackground.forEach(([element, wasInert]) => { element.inert = wasInert; });
    modalBackground = [];
    document.body.style.overflow = previousOverflow;
  }
  function restoreFocus() {
    if (returnFocus?.isConnected && !returnFocus.closest('[hidden]')) returnFocus.focus({preventScroll: true});
  }
  function hidePreferences(restoreBanner = true) {
    preferences.hidden = true;
    releaseModal();
    if (restoreBanner && bannerWasOpen && undecided()) banner.hidden = false;
    restoreFocus();
  }
  function showPreferences() {
    if (fallbackStarted) return window.privacyBanner?.showPreferences?.();
    if (!preferences.hidden) return;
    clearErrors();
    syncInputs();
    returnFocus = document.activeElement;
    bannerWasOpen = !banner.hidden;
    banner.hidden = true;
    preferences.hidden = false;
    if (!modalBackground.length) {
      previousOverflow = document.body.style.overflow;
      modalBackground = [...document.body.children].filter(el => el !== root && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName)).map(el => [el, el.inert]);
      modalBackground.forEach(([el]) => { el.inert = true; });
      document.body.style.overflow = 'hidden';
    }
    root.querySelector('#shopify-pc__prefs__header-close').focus({preventScroll: true});
  }
  function showBanner(force = false) {
    if (fallbackStarted) return;
    if (preferences.hidden && (force || (api.shouldShowBanner() && undecided()))) banner.hidden = false;
  }
  function save(values) {
    if (saving) return;
    const sequence = ++saveSequence;
    clearErrors();
    const errorContainer = preferences.hidden ? banner.querySelector('.shopify-pc__banner__body') : root.querySelector('.shopify-pc__prefs__intro-main');
    setBusy(true);
    const finish = error => {
      if (!saving || sequence !== saveSequence) return;
      clearTimeout(watchdog);
      setBusy(false);
      if (error) { showError(errorContainer); return; }
      const stored = consent();
      const saved = categories.every(key => stored[key] === (values[key] ? 'yes' : 'no'));
      if (!saved) { showError(errorContainer); return; }
      banner.hidden = true;
      hidePreferences(false);
      syncInputs();
    };
    const watchdog = setTimeout(() => finish(new Error('Consent save timed out')), 15000);
    try { api.setTrackingConsent(values, finish); }
    catch (error) { finish(error); }
  }
  function saveAll(value) { save(Object.fromEntries(categories.map(key => [key, value]))); }

  function mount() {
    if (fallbackStarted) return;
    const stylesheet = document.getElementById('eg-cookie-banner-style');
    if (!stylesheet?.sheet) { fallback(); return; }
    root = document.createElement('div');
    root.dataset.edenCookieRoot = '';
    root.innerHTML = templates.banner + templates.preferences;
    document.body.append(root);
    if (getComputedStyle(root).getPropertyValue('--eden-cookie-style-ready').trim() !== '1') { fallback(); return; }
    banner = root.querySelector('#shopify-pc__banner');
    preferences = root.querySelector('#shopify-pc__prefs');
    dialog = root.querySelector('#shopify-pc__prefs__dialog');
    const on = (id, action) => root.querySelector(`#${id}`).addEventListener('click', action);
    on('shopify-pc__banner__btn-accept', () => saveAll(true));
    on('shopify-pc__banner__btn-decline', () => saveAll(false));
    on('shopify-pc__banner__btn-manage-prefs', showPreferences);
    on('shopify-pc__prefs__header-accept', () => saveAll(true));
    on('shopify-pc__prefs__header-decline', () => saveAll(false));
    on('shopify-pc__prefs__header-save', () => save(Object.fromEntries(categories.map(key => [key, root.querySelector(`#shopify-pc__prefs__${key}-input`).checked]))));
    on('shopify-pc__prefs__header-close', () => hidePreferences());
    on('shopify-pc__prefs__overlay', () => { if (!saving) hidePreferences(); });
    preferences.addEventListener('change', event => {
      if (event.target.matches('input[type="checkbox"]')) syncIcon(event.target);
    });
    preferences.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !saving) { event.preventDefault(); hidePreferences(); }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]')].filter(el => el.tabIndex >= 0);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      if (!link || link.hasAttribute('data-eg-cookie-preferences')) return;
      const href = link.getAttribute('href');
      if (href === '#shopify-pc__prefs' || href === '/#shopify-pc__prefs') {
        event.preventDefault(); showPreferences();
      }
    });
    document.addEventListener('visitorConsentCollected', () => {
      if (!saving && !undecided()) { banner.hidden = true; syncInputs(); }
    });
    syncInputs();
    showBanner();
  }

  const facade = {
    showPreferences: () => ready.then(showPreferences),
    showBanner: () => ready.then(() => showBanner(true)),
    loadBanner: () => ready.then(() => showBanner())
  };
  window.edenCookieBanner = facade;
  window.privacyBanner = facade;
  ready = new Promise(resolve => {
    const watchdog = setTimeout(() => { fallback(); resolve(); }, 10000);
    if (!window.Shopify?.loadFeatures) { clearTimeout(watchdog); fallback(); resolve(); return; }
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        clearTimeout(watchdog);
        api = window.Shopify.customerPrivacy;
        if (error || !api?.setTrackingConsent || !api?.currentVisitorConsent || !api?.shouldShowBanner || api.saleOfDataRegion?.()) fallback();
        else { try { mount(); } catch (_) { fallback(); } }
        resolve();
      });
    } catch (_) { clearTimeout(watchdog); fallback(); resolve(); }
  });
})();
